<template>
  <div class="table-responsive">
    <table class="table custom-table mb-0">
      <thead>
        <tr>
          <th>Project Name</th>
          <th>Progress</th>
          <th class="text-end">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in AdminRecentProject" :key="item.id">
          <td>
            <h2>
              <router-link to="project-view">{{ item.Name }}</router-link>
            </h2>
            <small class="block text-ellipsis">
              <span>{{ item.Open }}</span> <span class="text-muted">open tasks, </span>
              <span>{{ item.num }}</span>
              <span class="text-muted ms-1">tasks completed</span>
            </small>
          </td>
          <td>
            <div class="progress progress-xs progress-striped">
              <div
                :class="item.Class"
                role="progressbar"
                data-bs-toggle="tooltip"
                :title="item.Title"
              ></div>
            </div>
          </td>
          <td class="text-end">
            <div class="dropdown-action">
              <a-dropdown :trigger="['click']" placement="bottomRight">
                <a href="javascript:;" class="action-dots"><i class="fa-solid fa-ellipsis-vertical"></i></a>
                <template #overlay>
                  <a-menu>
                <a-menu-item key="item-1"
                  ><i class="fa-solid fa-pencil m-r-5"></i> Edit</a-menu-item>
                <a-menu-item key="item-2"
                  ><i class="fa-regular fa-trash-can m-r-5"></i> Delete</a-menu-item>
              </a-menu>
                </template>
              </a-dropdown>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import AdminRecentProject from "@/assets/json/admin-recent-project.json";
export default {
  data() {
    return {
      AdminRecentProject: AdminRecentProject,
    };
  },
};
</script>
